import { UpsertEventTypeModal } from '../UpsertEventType/UpsertEventTypeModal'
import { createCreateButton } from '../../../../components/CreateButton'
import translations from '../Actions.i18n.json'

export const EventTypeCreateButton = createCreateButton({
  UpsertModal: UpsertEventTypeModal,
  translations,
})
